import { AttachMoney, Schedule } from "@mui/icons-material";
import { Chip, Stack, Tooltip } from "@mui/material";
import { useCurrencyFormatter } from "../hooks/useCurrencyFormatter";
import MortgageSimulator from "../simulator";
import { yearsAndMonths } from "../utils";

export default function Insights({
  moreExpensive,
  sim,
}: {
  moreExpensive: number | null;
  sim?: MortgageSimulator;
}) {
  const c = useCurrencyFormatter();

  const showActualTerm =
    sim?.additionalCapitalRepayments &&
    sim.monthsPaidOffSooner !== null &&
    sim.monthsPaidOffSooner > 0;

  if (moreExpensive === null && !showActualTerm) {
    return null;
  }
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {moreExpensive !== null && moreExpensive < 0.001 ? (
        <Tooltip
          title="This is the cheapest option. Interest earned on savings is included."
          arrow
        >
          <Chip
            icon={<AttachMoney />}
            label="Cheapest Option"
            color="success"
          />
        </Tooltip>
      ) : moreExpensive !== null ? (
        <Tooltip
          title={`This costs ${c(moreExpensive)} more than the cheapest option. Interest earned on savings is included.`}
          arrow
        >
          <Chip
            icon={<AttachMoney />}
            label={`+ ${c(moreExpensive)}`}
            color="warning"
          />
        </Tooltip>
      ) : null}
      {showActualTerm && (
        <Tooltip
          title={
            <>
              <strong>Actual Term</strong> — With ACRs enabled, the mortgage is
              paid off in {yearsAndMonths(sim.numberOfMonths, true)} instead of
              the original {yearsAndMonths(sim.mortgage.termMonths, true)} term,
              which is {yearsAndMonths(sim.monthsPaidOffSooner, true)} sooner.
            </>
          }
          arrow
        >
          <Chip
            icon={<Schedule />}
            label={yearsAndMonths(sim.numberOfMonths)}
            color="info"
          />
        </Tooltip>
      )}
    </Stack>
  );
}
